export const ESTADOS_PETICIONARIO_MAP = {
  'Pdte. de terceros': 'En Gestión',
  Asignada: 'Creada',
}

export const SSPP_ROLES = ['soporte_procesos', 'coordinador_sspp']

export const SSPP_PERMISSIONS = ['coordinador_sspp', 'gestion_sspp']

export const canViewSSPPStates = (role, permissions = {}) => {
  return SSPP_ROLES.includes(role) || SSPP_PERMISSIONS.some((permission) => permissions[permission])
}

export const mapEstadoForPeticionario = (estadoSSPP) => {
  if (!estadoSSPP) return null
  return ESTADOS_PETICIONARIO_MAP[estadoSSPP] || estadoSSPP
}
